import React from 'react';
import { motion } from 'framer-motion';
import { FileText, UserCheck, Home, Zap, Network } from 'lucide-react';
const steps = [{
  icon: FileText,
  title: 'Diagnóstico'
}, {
  icon: UserCheck,
  title: 'Perfil validado'
}, {
  icon: Home,
  title: 'Match inteligente'
}, {
  icon: Zap,
  title: 'Postulación rápida'
}, {
  icon: Network,
  title: 'Red conectada'
}];
export function EcosystemVision() {
  return <section className="py-24 px-6 bg-gray-900 text-white overflow-hidden" data-id="element-69">
      <div className="max-w-5xl mx-auto" data-id="element-70">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-71">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4" data-id="element-72">
            Esto recién empieza
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-73">
            Estamos construyendo una nueva forma de arrendar
          </p>
        </motion.div>

        <div className="relative" data-id="element-74">
          {/* Connecting line */}
          <div className="hidden md:block absolute top-1/2 left-0 right-0 h-0.5 bg-gray-800 -translate-y-1/2 z-0" data-id="element-75" />

          <div className="grid grid-cols-1 md:grid-cols-5 gap-8 relative z-10" data-id="element-76">
            {steps.map((step, index) => {
            const Icon = step.icon;
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex flex-col items-center text-center group" data-id="element-77">
                  <div className="w-16 h-16 rounded-2xl bg-gray-800 border border-gray-700 flex items-center justify-center mb-6 group-hover:bg-brand-600 group-hover:border-brand-500 transition-colors" data-id="element-78">
                    <Icon size={24} className="text-gray-300 group-hover:text-white transition-colors" data-id="element-79" />
                  </div>
                  <div className="text-sm font-bold text-gray-500 mb-2" data-id="element-80">
                    Paso {index + 1}
                  </div>
                  <h3 className="text-base font-medium text-gray-200" data-id="element-81">
                    {step.title}
                  </h3>
                </motion.div>;
          })}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="mt-20 text-center" data-id="element-82">
          <p className="text-lg md:text-xl font-medium text-gray-300" data-id="element-83">
            Partimos diciéndote si tienes opciones. Luego conectamos todo.
          </p>
        </motion.div>
      </div>
    </section>;
}